import React, { useRef, useState } from "react";
import { FiMessageSquare, FiRefreshCw, FiSend } from "react-icons/fi";
import appApi from "../../assets/utils/AppApi";
import styles from "./styles.module.css";

const statusLabels = { Pending: "در انتظار بررسی", Accepted: "پذیرفته شده", Rejected: "رد شده" };

export default function ReportCardObjection({ card, objection, canObject, onRefresh }) {
  const [statement, setStatement] = useState("");
  const [submitted, setSubmitted] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const saving = useRef(false);
  const current = objection || submitted;
  const submit = async event => {
    event.preventDefault();
    if (saving.current || current) return;
    if (!statement.trim()) {
      setError("متن اعتراض را وارد کنید.");
      return;
    }
    saving.current = true;
    setBusy(true);
    setError("");
    try {
      const { data } = await appApi.post("/reportcardobjection/create", {
        reportCard: card._id, userStatement: statement.trim()
      });
      setSubmitted(data);
    } catch (err) {
      setError(err.response?.data?.msgFa || "ثبت اعتراض ممکن نشد. دوباره تلاش کنید.");
      if (err.response?.status === 409) onRefresh();
    } finally {
      saving.current = false;
      setBusy(false);
    }
  };

  return <section className={styles.objection} aria-labelledby="objection-title">
    <div className={styles.objectionHeader}>
      <div className={styles.objectionHeading}>
        <span className={styles.objectionIcon}><FiMessageSquare aria-hidden="true" /></span>
        <h2 id="objection-title">اعتراض به کارنامه</h2>
      </div>
      {current && <p role="status" className={`${styles.objectionBadge} ${styles[`objection${current.status}`] || ""}`}>
        وضعیت اعتراض: {statusLabels[current.status] || current.status}
      </p>}
    </div>
    <div className={styles.objectionBody}>
    {current ? <>
      <div className={styles.objectionMessage}>
        <h3>شما</h3>
        <p>{current.userStatement}</p>
      </div>
      {current.adminStatement && <div className={`${styles.objectionMessage} ${styles.objectionReply}`}>
        <h3>پاسخ مدیر</h3><p>{current.adminStatement}</p>
      </div>}
      <div className={styles.objectionActions}>
        <button type="button" className={styles.objectionRefresh} onClick={onRefresh}><FiRefreshCw aria-hidden="true" />بازخوانی وضعیت اعتراض</button>
      </div>
    </> : canObject ? <form onSubmit={submit}>
      <label className={styles.objectionLabel} htmlFor="objection-statement">متن اعتراض</label>
      <textarea id="objection-statement" className={styles.objectionInput} rows={5} maxLength={5000}
        required disabled={busy} value={statement} placeholder="اعتراض خود را اینجا بنویسید…"
        aria-invalid={Boolean(error)} aria-describedby={error ? "objection-error" : undefined}
        onChange={event => setStatement(event.target.value)} />
      {error && <p id="objection-error" className={styles.objectionError} role="alert">{error}</p>}
      <div className={styles.objectionActions}>
        <button className={`${styles.button} ${styles.objectionSubmit}`} type="submit" disabled={busy}><FiSend aria-hidden="true" />{busy ? "در حال ثبت…" : "ثبت اعتراض"}</button>
      </div>
    </form> : <p className={styles.objectionClosed}>{card.allowObjection ? "مهلت ثبت اعتراض پایان یافته است." : "ثبت اعتراض برای این کارنامه فعال نیست."}</p>}
    </div>
  </section>;
}
